import React from 'react';
import { useState, useEffect, lazy, Suspense } from 'react';
import { Tabs, Tab, Container, Row, Col } from 'react-bootstrap';
import '../assets/css/Cogen.css';
import { UseIcon } from './hooks/UseIcon';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector } from 'react-redux';
import {
	jobRequest,
	searchJobRequest,
} from '../store/jobOpportunities/async-actions';
import { Header, Footer } from './Container';
const JobOpportunities = lazy(() =>
	import('./features/member/JobOpportunities')
);
const JobSearch = lazy(() => import('./features/member/JobSearch'));
const JobHistory = lazy(() => import('./features/member/JobHistory'));

function Member(props) {
	const profile = useSelector(state => state.auth.profile);
	const tags = profile.user.tags.map((item, i) => {
		return item.id;
	});

	useEffect(() => {
		// props.jobList({tags: tags});
		// props.searchJobList({tags: tags});

		console.group('Onesignal');
		console.log('One Signal', window?.OneSignal?.setExternalUserId);

		if (window?.OneSignal) {
			window.OneSignal?.setExternalUserId &&
				window.OneSignal.setExternalUserId(profile.user.public_id);
		}

		console.groupEnd();
	}, []);

	return (
		<Container fluid='true' style={{ overflow: 'hidden' }}>
			<Header type='member' />
			<Suspense fallback={<Spinner animation='grow' />}>
				<Row className='mt-5 mb-5' style={{ minHeight: 'calc(100vh - 183px)' }}>
					<Col className='p-0'>
						<Tabs
							defaultActiveKey='jobOpportunities'
							id='controlled-tab-example'
							className='tabs-custom'
						>
							<Tab
								className='mr-2 ml-2'
								eventKey='jobOpportunities'
								title={
									<UseIcon
										icon={'job'}
										title='Job Opportunities'
										simg='tab-icon'
									/>
								}
							>
								<JobOpportunities profile={profile} />
							</Tab>
							<Tab
								className='mr-2 ml-2'
								eventKey='jobSearch'
								title={
									<UseIcon icon={'job'} title='Job Search' simg='tab-icon' />
								}
							>
								<JobSearch profile={profile} />
							</Tab>
							<Tab
								className='mr-2 ml-2'
								eventKey='jobHistory'
								title={
									<UseIcon icon={'job'} title='Job History' simg='tab-icon' />
								}
							>
								<JobHistory profile={profile} />
							</Tab>
						</Tabs>
					</Col>
				</Row>
				<Footer />
			</Suspense>
		</Container>
	);
}

// const mapDispatchToProps = dispatch => {
// 	return {
// 		// jobList: (type) => dispatch(searchJobRequest(null)),
// 		// searchJobList: (type) => dispatch(searchJobRequest(type)),
// 	};
// };
export default Member;
